import axios from "axios";



export const getBaseUrl = () => {
    const origin = window.location.origin;
    const path = window.location.pathname;

    const isCargo = path.startsWith("/cargo");
    const isProd = origin.includes("mavenconnect.biz");

    if (isCargo) {
        return isProd
            ? "https://cargoapi.mavenconnect.tech/api"
            : "https://stagecargoapi.mavenconnect.tech/api";
    }

    return isProd
        ? "https://busapi.mavenconnect.tech/api"
        : "https://stagebusapi.mavenconnect.tech/api";
};


let BaseUrl = getBaseUrl();

export { BaseUrl };

const HttpGet = async (url, params, logintoken = null) => {
    return new Promise(async function (resolve, reject) {
        const completeUrl = getBaseUrl() + url;
        const token = localStorage.getItem('token');
        axios({
            method: "get",
            url: completeUrl,
            params: {
                ...params,
                usage: 'dev'
            },
            headers: {
                "Accept": "application/json",
                ...(logintoken && {
                    Token: logintoken
                }),
            },
        })
            .then((response) => {
                if (response && response.status === 200) {
                    return resolve(response);
                }
                return resolve(response);
            })
            .catch((err) => {
                return reject(err);
            });
    });
};

const HttpCall = async (url, method, params, body, tokenValue) => {
    return new Promise(async function (resolve, reject) {
        const completeUrl = getBaseUrl() + url;
        const token = tokenValue || localStorage.getItem('token');
        axios({
            method: method,
            url: completeUrl,
            data: body,
            params: {
                ...params,
                usage: 'dev'
            },
            headers: {
                "Accept": "application/json",
                "Token": token,
            },
        })
            .then((response) => {
                if (response && response.status === 200) {
                    return resolve(response);
                }
                return resolve(response);
            })
            .catch((err) => {
                return reject(err);
            });
    });
};

export default {
    HttpGet,
    HttpCall,
}